import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { _throw } from 'rxjs/observable/throw';
import { NotificationService } from '../service/notification.service';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EncriptDecriptService } from '../../../services/encriptdecript';


@Injectable()
export class AdminDashboardService {

  constructor(private Http: HttpClient, private router: Router,
    public activeModal: NgbActiveModal,
    private encriptDecriptService:EncriptDecriptService,
    private notificationService: NotificationService) { }
  private standardHeaders() {
    return {
      'Content-Type': 'application/json',
      'token': this.encriptDecriptService.getKeyLocalStorage('token')
    };

  }

  goToLoginPage() {
    this.activeModal.close();
    this.router.navigate(['/login']);
    localStorage.clear();
    sessionStorage.clear();
    this.notificationService.sessionExpaireNotification();
  }

  public getAdminDashboardAnalytics(orgId: Number) {
    return this.Http.post(environment.api_url1 + 
      '/category/adminGraphAnalytics?organisationId='+ orgId, {},
      { headers: this.standardHeaders() })
      .pipe(
        map((response: any) => {
          return response;
        }),
        catchError(error => {
          if (error.status == 401) { this.goToLoginPage(); }
          return _throw(error);
        })
      );
  }


  //  get admin dashboard courses statistics 
  public getAdminDashBoardCourseAnalytics(orgId: any, categoryIds: any): Observable<any> {
    return this.Http.get(environment.api_url1 +
       '/adminDashboard/categoryAnalyticsDetails?categoryIds[]='
        + categoryIds + '&organisationId=' + orgId ,
        { headers: this.standardHeaders() })
        .pipe(
          map((response: any) => {
            return response;
          }),
          catchError(error => {
            if (error.status == 401) { this.goToLoginPage(); }
            return _throw(error);
          })
        );
  }

  public getAdminDashBoardCourseAnalyticsViewApi(orgId: any, categoryIds: any): Observable<any> {
    return this.Http.get(environment.api_url1 +
       '/adminDashboard/categoryAnalyticsView?categoryIds[]='
        + categoryIds + '&organisationId=' + orgId ,
        { headers: this.standardHeaders() })
        .pipe(
          map((response: any) => {
            return response;
          }),
          catchError(error => {
            if (error.status == 401) { this.goToLoginPage(); }
            return _throw(error);
          })
        );
  }

  public getTopicsForSelectedCourse(categoryId: any, orgId: any): Observable<any> {
    return this.Http.get(environment.api_url1 
    + '/adminDashboard/courseAnalyticsView?categoryId=' +
    categoryId +'&organisationId=' + orgId,
    { headers: this.standardHeaders() })
    .pipe(
      map((response: any) => {
        return response;
      }),
      catchError(error => {
        if (error.status == 401) { this.goToLoginPage(); }
        return _throw(error);
      })
    );
  }
  public getSectionsForSelectedTopic(courseId:any, orgId: any): Observable<any> {
    return this.Http.get(environment.api_url1 
    + '/adminDashboard/lessonAnalyticsView?courseId='+courseId+'&organisationId=' + orgId,
    { headers: this.standardHeaders() })
    .pipe(
      map((response: any) => {
        return response;
      }),
      catchError(error => {
        if (error.status == 401) { this.goToLoginPage(); }
        return _throw(error);
      })
    );
  }
  public getStudentsForSelectedSection(lessonId:any,orgId: any): Observable<any> {
    return this.Http.get(environment.api_url1 
    + '/adminDashboard/lessonUserAnalyticsView?lessonId='+lessonId+'&organisationId=' + orgId,
    { headers: this.standardHeaders() })
    .pipe(
      map((response: any) => {
        return response;
      }),
      catchError(error => {
        if (error.status == 401) { this.goToLoginPage(); }
        return _throw(error);
      })
    );
  }

  //  get admin dashboard Students statistics 
  public getAdminDashBoardStudentAnalytics(userIds: any, orgId: any): Observable<any> {
    return this.Http.get(environment.api_url1 
    + '/adminDashboard/userAnalyticsDetails?userIds[]=' +
    userIds +'&organisationId=' + orgId,
    { headers: this.standardHeaders() })
    .pipe(
      map((response: any) => {
        return response;
      }),
      catchError(error => {
        if (error.status == 401) { this.goToLoginPage(); }
        return _throw(error);
      })
    );
  }

   //  get admin dashboard Students statistics View API due to performance optimization
   public getAdminDashBoardStudentAnalyticsView(userIds: any, orgId: any): Observable<any> {
    return this.Http.get(environment.api_url1 
    + '/adminDashboard/userAnalyticsView?userIds[]=' +
    userIds +'&organisationId=' + orgId,
    { headers: this.standardHeaders() })
    .pipe(
      map((response: any) => {
        return response;
      }),
      catchError(error => {
        if (error.status == 401) { this.goToLoginPage(); }
        return _throw(error);
      })
    );
  }

  public getCoursesForSelectedStudent(userId: any, orgId: any): Observable<any> {
    return this.Http.get(environment.api_url1 
    + '/adminDashboard/userCategoryAnalyticsView?userId=' +
    userId +'&organisationId=' + orgId,
    { headers: this.standardHeaders() })
    .pipe(
      map((response: any) => {
        return response;
      }),
      catchError(error => {
        if (error.status == 401) { this.goToLoginPage(); }
        return _throw(error);
      })
    );
  }
  public getTopicsForSelectedStudent(userId: any,categoryId:any, orgId: any): Observable<any> {
    return this.Http.get(environment.api_url1 
    + '/adminDashboard/userCourseAnalyticsView?userId=' +
    userId +'&categoryId='+categoryId+'&organisationId=' + orgId,
    { headers: this.standardHeaders() })
    .pipe(
      map((response: any) => {
        return response;
      }),
      catchError(error => {
        if (error.status == 401) { this.goToLoginPage(); }
        return _throw(error);
      })
    );
  }
  public getSectionsForSelectedStudent(userId: any, courseId:any,orgId: any): Observable<any> {
    return this.Http.get(environment.api_url1 
    + '/adminDashboard/userLessonAnalyticsView?userId=' +
    userId +'&courseId='+courseId+'&organisationId=' + orgId,
    { headers: this.standardHeaders() })
    .pipe(
      map((response: any) => {
        return response;
      }),
      catchError(error => {
        if (error.status == 401) { this.goToLoginPage(); }
        return _throw(error);
      })
    );
  }


  //  get admin dashboard Three level of status (YT,IP,CO) 
  public getAdminDashBoardStatus(): Observable<any> {
    return this.Http.get(environment.api_url1 + '/categoryStatus/catalog',
     {headers:this.standardHeaders()})
     .pipe(
      map((response: any) => {
        return response;
      }),
      catchError(error => {
        if (error.status == 401) { this.goToLoginPage(); }
        return _throw(error);
      })
    );
  }


  // getUser attemps for perticular course 

  getUserAttemps(Obj:any):Observable<any>{
    return this.Http.get(environment.api_url1+'/lesson/attemptDetails?lessonId='+
    Obj.lessonId+'&userId='+Obj.userId,{headers:this.standardHeaders()})
    .pipe(
      map((response: any) => {
      return response;
    }),
    catchError(error => {
      if (error.status == 401) { this.goToLoginPage(); }
      return _throw(error);
    })
  );
  }

}




// WEBPACK FOOTER //
// /home/jenkins/hornbillfx-elms-v2/src/app/feature-modules/admin/admin-services/admin-dashboard.service.ts